import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createSuper";
import Boss from '@tencent/vft-common/Boss';
import isObject from 'lodash-es/isObject';
import toPairs from 'lodash-es/toPairs';
import ISpeedReport from './ISpeedReport';
var BOSS_CONFIG = {
  bossId: 4710,
  pwd: 8476392
};

var LJReport = /*#__PURE__*/function (_ISpeedReport) {
  _inherits(LJReport, _ISpeedReport);

  var _super = _createSuper(LJReport);

  /**
   * 
   * @param {object} options
   * @param {string} options.project - 项目id(在棱镜平台申请的项目id)
   * @param {string} options.page - 页面id
   */
  function LJReport() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        project = _ref.project,
        page = _ref.page;

    _classCallCheck(this, LJReport);

    _this = _super.call(this);
    _this._boss = new Boss(BOSS_CONFIG);

    if (!project || !page) {
      throw new Error('[LJReport]project and page is required');
    }

    _this._project = project;
    _this._page = page;
    return _this;
  }

  _createClass(LJReport, [{
    key: "setProject",
    value: function setProject(project) {
      this._project = project;
      return this;
    }
  }, {
    key: "setPage",
    value: function setPage(page) {
      this._page = page;
    }
  }, {
    key: "setTags",
    value: function setTags(tags) {
      this._tags = tags;
      return this;
    }
    /**
     * 
     * @param {object} params
     * @param {string} params.modId - 模块id
     * @param {object} params.metrics - 上报指标的key-value对象
     * @param {object} params.tags - 维度标签
     */

  }, {
    key: "report",
    value: function report() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$modId = _ref2.modId,
          modId = _ref2$modId === void 0 ? '未知模块' : _ref2$modId,
          metrics = _ref2.metrics,
          _ref2$tags = _ref2.tags,
          tags = _ref2$tags === void 0 ? this._tags : _ref2$tags;

      var marks = {};

      this._eMarks.forEach(function (v, k) {
        marks[k] = v;
      });

      this.clear();
      return this._boss.report({
        busi: this._buildBizId(modId),
        metrics: this._buildMetrics(_objectSpread(_objectSpread({}, marks), metrics)),
        tags: this._buildTags(tags)
      });
    }
  }, {
    key: "_buildMetrics",
    value: function _buildMetrics(metrics) {
      if (!isObject(metrics)) {
        return '';
      }

      return toPairs(metrics).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            k = _ref4[0],
            v = _ref4[1];

        return "".concat(k, "=").concat(v);
      }).join(' ');
    }
  }, {
    key: "_buildTags",
    value: function _buildTags(tags) {
      if (!isObject(tags)) {
        return '';
      }

      return toPairs(tags).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            k = _ref6[0],
            v = _ref6[1];

        return "".concat(k, "=").concat(v);
      }).join(' ');
    }
  }, {
    key: "_buildBizId",
    value: function _buildBizId(modId) {
      return "".concat(this._project, ".").concat(this._page, ".").concat(modId);
    }
  }]);

  return LJReport;
}(ISpeedReport);

export { LJReport as default };